$(document).ready(function() {
	
	/*** frequently asked questions ***/
	$('.pro3-faq-question').on('click', function() {
		$(this).parent().toggleClass('pro3-faq-active');
	});
	
	/*** contact form logic ***/
	// on state change
	$('.pro3-select-states select').on('change', function() {
		var state = $(this).val();
		console.log('state:', state);
		if (state == '') {
			// reset cities, show all options
			$('.pro3-select-cities option.gf_placeholder').prop('selected', true);
			$('.pro3-select-cities option').show();
			// reset facilities, show all options
			$('.pro3-select-facilities option.gf_placeholder').prop('selected', true);
			$('.pro3-select-facilities option').show();
		} else {
			// reset states
			$('.pro3-select-cities option.gf_placeholder').prop('selected', true);
			$('.pro3-select-cities option:not(.gf_placeholder)').hide();
			$('.pro3-select-cities option[data-state="' + state + '"]').show();
			// reset facilities
			$('.pro3-select-facilities option.gf_placeholder').prop('selected', true);
			$('.pro3-select-facilities option:not(.gf_placeholder)').hide();
			$('.pro3-select-facilities option[data-state="' + state + '"]').show();
		}
	});
	
	// on city change
	$('.pro3-select-cities select').on('change', function() {
		var city = $(this).val();
		console.log('city:', city);
		if (city == '') {
			// hide facilities field
			// $('.pro3-select-facilities').slideUp();
			// reset facilities, show all options
			$('.pro3-select-facilities option.gf_placeholder').prop('selected', true);
			$('.pro3-select-facilities option').show();
		} else {
			// get state to go with city
			var state = $('option:selected', this).attr('data-state');
			// show facilities field
			// $('.pro3-select-facilities').slideDown();
			// reset facilities
			$('.pro3-select-facilities option.gf_placeholder').prop('selected', true);
			$('.pro3-select-facilities option:not(.gf_placeholder)').hide();
			$('.pro3-select-facilities option[data-state="' + state + '"][data-city="' + city + '"]').show();
			$('.pro3-select-facilities option[data-state="unknown"][data-city="unknown"]').show();
			$('.pro3-select-facilities option[data-state="other"][data-city="other"]').show();
		}
	});
	
	// hold the mega menu open when interacting with the google places autocomplete
	$('.pro3-mega-sub-menu-item-find-parking-form input[name="google-places-autocomplete"]').on('focus', function() {
		$(this).parents('.has-mega-menu').addClass('pro3-mega-menu-stay-open');
	});
	
	// close the mega menu open when done interacting with the google places autocomplete
	$('.pro3-mega-sub-menu-item-find-parking-form input[name="google-places-autocomplete"]').on('blur', function() {
		$(this).parents('.has-mega-menu').removeClass('pro3-mega-menu-stay-open');
	})
	
	// simple map on custom facility landing page
	$('.pro3-half-and-half-map').each(function(index, element) {
		var id = $(element).attr('id');
		var lat = $(element).attr('data-latitude');
		var lng = $(element).attr('data-longitude');
		simpleMap(lat, lng, id);
	});

	// block :: big photo tabs
	$('.pro3-big-photo-tabs').each(function(index, element) {
		var photo_tabs_slider = $('.pro3-big-photo-tabs-group', element).flickity({
			adaptiveHeight: true,
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			percentPosition: true,
			prevNextButtons: false,
			resize: true
		});
		$('.pro3-big-photo-tabs-menu', element).on('click', '.pro3-big-photo-tabs-menu-button', function() {
			var index = $(this).attr('data-index');
			var buttons = $(this).siblings();
			$(buttons).removeClass('pro3-big-photo-tabs-menu-button-active');
			$(this).addClass('pro3-big-photo-tabs-menu-button-active');
			photo_tabs_slider.flickity('select', index);
		});
	});

	// block :: blog posts
	$('.pro3-section-blog-posts').each(function(index, element) {
		var blog_posts_slider = $('.pro3-blog-posts-slider', element).flickity({
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			// percentPosition: true,
			prevNextButtons: false,
			resize: true
		});
		$('.pro3-slider-button-previous', element).on('click', function() {
			blog_posts_slider.flickity('previous');
			var flkty = blog_posts_slider.data('flickity');
			var current_slide = flkty.selectedIndex;
			var total_slides = flkty.slides.length - 1;
			if (current_slide === 0) {
				$('.pro3-slider-button-previous', element).prop('disabled', true);
			} else {
				$('.pro3-slider-button-previous', element).prop('disabled', false);
			}
			if (current_slide == total_slides) {
				$('.pro3-slider-button-next', element).prop('disabled', true);
			} else {
				$('.pro3-slider-button-next', element).prop('disabled', false);
			}
		});
		$('.pro3-slider-button-next', element).on('click', function() {
			blog_posts_slider.flickity('next');
			var flkty = blog_posts_slider.data('flickity');
			var current_slide = flkty.selectedIndex;
			var total_slides = flkty.slides.length - 1;
			if (current_slide === 0) {
				$('.pro3-slider-button-previous', element).prop('disabled', true);
			} else {
				$('.pro3-slider-button-previous', element).prop('disabled', false);
			}
			if (current_slide == total_slides) {
				$('.pro3-slider-button-next', element).prop('disabled', true);
			} else {
				$('.pro3-slider-button-next', element).prop('disabled', false);
			}
		});
	});

	// block :: full width slider
	$('.pro3-full-width-image-slider').each(function(index, element) {
		var full_width_slider = $(element).flickity({
			cellAlign: 'left',
			contain: true
		});
	});

	// block :: map with statistics
	$('.pro3-statistics-group').each(function(index, element) {
		var statistics = $('.pro3-statistic', element);
		$(statistics).each(function(index, statistic) {
			var target = $('.pro3-statistic-number', statistic)[0];
			var end_number = $(target).attr('data-number') * 1;
			var prefix = $(target).attr('data-prefix');
			var suffix = $(target).attr('data-suffix');
			var options = {
				startVal: 0,
				duration: 3,
				useGrouping: false,
				useEasing: true,
				prefix: prefix,
				suffix: suffix,
				enableScrollSpy: true,
				scrollSpyOnce: true
			};
			var counter = new CountUp(target, end_number, options);
		});
	});

	// block :: resources index
	$('#pro3-blog-posts-content-type').on('change', function() {
		var value = $(this).val();
		window.location.href = value;
	});

	// block :: video & video grid
	$('.pro3-video-video').on('click', function() {
		$(this).addClass('pro3-video-video-clicked');
		var video_type = $(this).attr('data-video-type');
		console.log(video_type);
		if (video_type === 'embed') {
			var iframe = $(this).children('iframe');
			var src = $(iframe).attr('src');
			src = src + '&autoplay=1';
			$(iframe).attr('src', src);
		} else if (video_type === 'upload') {
			var video = $(this).children('video');
			$(video).get(0).play();
			console.log('video:', video);
		}
	});

	// block :: contact form tabs
	$('.pro3-contact-form-tabs-buttons-group').each(function(index, element) {
		$('.pro3-contact-form-tabs-button', element).on('click', function() {
			var tab = $(this).attr('data-tab');
			// manipulate buttons
			$('.pro3-contact-form-tabs-button', element).removeClass('pro3-contact-form-tabs-button-active');
			$(this).addClass('pro3-contact-form-tabs-button-active');
			// manipulate tabs
			$('.pro3-contact-form-tabs-content').removeClass('pro3-contact-form-tabs-content-active');
			$('.pro3-contact-form-tabs-content[data-tab="' + tab + '"]').addClass('pro3-contact-form-tabs-content-active');
		});
	});

});
